import React from "react";
import disclaimerData from "../../utils/AffiliateDisclaimerContent";

const AffiliateDisclaimer = ({ data }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-5xl font-bold text-gray-800 mb-6 mt-10">
        {data.title}
      </h1>
      {data.paragraphs.map((para, idx) => (
        <p key={idx} className="text-gray-700 text-base mb-4 leading-relaxed">
          {para}
        </p>
      ))}
    </div>
  );
};

export default function DisclaimerPage() {
  return <AffiliateDisclaimer data={disclaimerData} />;
}
